export default __webpack_public_path__ + "static/header.kontakt-22a365b8b71ce5d94cf1f1f6e26bc535.jpg";